/**
 * Browser Plugin
 *
 * This is a Microcosm plugin that will render the interface
 * when the the application starts.
 *
 * https://github.com/vigetlabs/microcosm/blob/master/docs/guides/04-plugins.md
 */

import DOM           from 'react-dom'
import React         from 'react'
import Relay         from '../../lib/relay'
import Routes        from '../components/routes'
import createHistory from 'history/lib/createBrowserHistory'
import { Router }    from 'react-router'

export default function Browser (app, selector, next) {
  if (!selector) {
    return next(`Unable to find selector ${ selector }`)
  }

  function createElement (Handler, state) {
    return (<Relay app={ app } props={ state } component={ Handler } />)
  }

  DOM.render((
    <Router history={ createHistory() } createElement={ createElement }>
      { Routes }
    </Router>
  ), document.querySelector(selector))

  next()
}



/** WEBPACK FOOTER **
 ** ./web/static/app/plugins/browser.jsx
 **/